import * as api from "services/api";
import { getErrors } from "helpers/error";

export const GET_CONTRACTS = "[CONTRACT] GET_CONTRACTS";
export const GET_CONTRACTS_SUCCESS = "[CONTRACT] GET_CONTRACTS_SUCCESS";
export const GET_CONTRACTS_FAILED = "[CONTRACT] GET_CONTRACTS_FAILED";

export const SET_VALUE = "[CONTRACT] SET_VALUE";
export const CLEAR_VALUES = "[CONTRACT] CLEAR_VALUES";

export function setValue(payload) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function getContractList(
	skip,
	take,
	filter,
	sort,
	desc,
	toExport,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({ type: GET_CONTRACTS });

		try {
			const { login } = getState();

			var response = await api.sendGet(
				`/contracts?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${filter ||
					"&filters=null"}`,
				{
					Authorization: "Bearer " + login.token
				}
			);

			let result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_CONTRACTS_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / take),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_CONTRACTS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_CONTRACTS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function getContractListExcel(skip, take, filter, sort, desc, callback) {
	return async (dispatch, getState) => {
		try {
			const { login } = getState();

			var response = await api.sendGet(
				`/contracts?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${filter ||
					"&filters=null"}`,
				{
					Authorization: "Bearer " + login.token
				}
			);

			let result = await response.json();

			if (result.isValid) {
				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				callback && callback(errors);
			}
		} catch (error) {
			console.log("error");
		}
	};
}
